import { useRef } from "react";
import { motion, useScroll, useSpring, useTransform, useReducedMotion } from "framer-motion";

// Scroll-linked entrance for a whole landing section: while it rises into view it grows from
// slightly smaller, lower and faded to its natural size. Unlike the sections' own one-shot
// `whileInView` fades, this is scrubbed with the scroll position (and reverses on scroll up),
// so the page moves with the visitor instead of just popping content in.
// No overflow/border-radius here: sections have dropdowns and floating elements that must
// be able to overflow their box.
const ScrollReveal = ({ children }) => {
  const ref = useRef(null);
  const prefersReducedMotion = useReducedMotion();

  // 0 when the section's top touches the bottom of the viewport, 1 once it's 45% up the screen
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "start 0.55"] });
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });

  const scale = useTransform(progress, [0, 1], [0.9, 1]);
  const y = useTransform(progress, [0, 1], [110, 0]);
  const opacity = useTransform(progress, [0, 0.75], [0.2, 1]);

  return (
    <motion.div
      ref={ref}
      style={prefersReducedMotion ? undefined : { scale, y, opacity, transformOrigin: "50% 0%" }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
